module.exports = __webpack_public_path__ + "static/media/prevPage.24f71530.svg";